import { atom, getDefaultStore } from "jotai";
import { Host } from "./types/host";

const store = getDefaultStore();
export const hostsAtom = atom<Host[]>([]);

const get = () => store.get(hostsAtom);

const set = (hosts: Host[]) => store.set(hostsAtom, hosts);

const add = (host: Host) => store.set(hostsAtom, [...store.get(hostsAtom), host]);

const updateName = (id: string, name: string) =>
	store.set(hostsAtom, store.get(hostsAtom).map((host) => host.id === id ? { ...host, name } : host));

const remove = (id: string) => store.set(hostsAtom, store.get(hostsAtom).filter((host) => host.id !== id));

const clear = () => store.set(hostsAtom, []);

export const hostStore = {
	get,
	set,
	add,
	updateName,
	remove,
	clear,
};
